import { SelectedData } from './selected-data.component';

export * from './selected-data.component';
export default SelectedData;

SelectedData.define('der-tailormade-appointment-booking-selected-data');

declare global {
    interface HTMLElementTagNameMap {
        'der-tailormade-appointment-booking-selected-data': SelectedData;
    }
}
